import { render, staticRenderFns } from "./AddPresentation.vue?vue&type=template&id=3afb6750&"
import script from "./AddPresentation.vue?vue&type=script&lang=js&"
export * from "./AddPresentation.vue?vue&type=script&lang=js&"
import style0 from "./AddPresentation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports